import QTable from 'quasar/src/components/table/QTable.js';

export function getInvoiceColumns(isInAdmin = false): QTable['columns'] {
  let columns = [
    {
      name: 'id',
      field: 'id',
      label: 'شماره',
      align: 'left'
    },
    {
      name: 'title',
      field: 'title',
      label: 'عنوان فاکتور',
      align: 'left',
      style: 'max-width:200px;'
    },
    {
      name: 'payable',
      field: 'payable',
      label: 'مبلغ',
      align: 'center',
      format: value => value?.toLocaleString() || value
    },
    {
      name: 'status',
      field: 'status',
      label: 'وضعیت',
      align: 'left'
    },
    {
      name: 'person_type',
      field: 'person_type',
      label: 'نوع فاکتور',
      align: 'left'
    },
    {
      name: 'user',
      field: 'user',
      label: 'کاربر',
      align: 'left',
      style: 'max-width:120px;'
    },
    {
      name: 'paid_at',
      field: 'paid_at',
      label: 'تاریخ پرداخت',
      align: 'left'
    },
    {
      name: 'due_date',
      field: 'due_date',
      label: 'سررسید',
      align: 'left'
    },
    {
      name: 'actions',
      field: 'actions',
      label: '',
      align: 'left'
    }]

  return (isInAdmin) ? columns : columns.filter(item => item.field !== 'user')
}